var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar",
    class: {
      closed: !_vm.isSidebarVisible && _vm.isOnMobile,
      collapsed: !_vm.isSidebarVisible && !_vm.isOnMobile
    },
    style: {
      maxWidth: _vm.sidebarMaxWidth()
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [_vm.isSidebarVisible ? _c('div', {
    staticClass: "text-center sidebar-logo"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToHome()
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.closeSidebar.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "logo"
    }
  })]), _c('span', {
    staticClass: "role-container text-primary text-center py-1"
  }, [_vm._v(_vm._s(_vm.$permissions.getActiveRole().name))]), _vm.isOnMobile ? _c('span', {
    staticClass: "menu-mobile-close expand-icon-wrapper",
    on: {
      "click": _vm.closeSidebar
    }
  }, [_c('i', {
    staticClass: "fas fa-times fa-2x text-primary"
  })]) : _vm._e()], 1) : _vm._e(), !_vm.isLayoutMobile || _vm.isLayoutMobileLandscape ? _c('button', {
    staticClass: "sidebar-toggle-button",
    attrs: {
      "aria-expanded": _vm.isSidebarVisible
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    class: _vm.isSidebarVisible ? 'fas fa-chevron-left' : 'fas fa-chevron-right'
  })]) : _vm._e(), _vm.isImpersonating && _vm.isSidebarVisible ? _c('div', {
    staticClass: "border-left border-danger d-flex justify-content-between align-items-center py-2 px-4"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t("Impersonating user!")))]), _c('button', {
    staticClass: "btn btn-sm btn-danger text-white",
    on: {
      "click": _vm.onExitImpersonationClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Stop")) + " ")])]) : _vm._e()]), _vm.isSidebarVisible ? _c('div', {
    staticClass: "text-center p-3"
  }, [_c('i', {
    staticClass: "global-sidebar-icon fa fa-solid fa-globe text-primary mr-2"
  }), _c('span', {
    staticClass: "user-title"
  }, [_vm._v(_vm._s(_vm.$t("Global Settings")))])]) : _vm._e(), _vm.isSidebarVisible ? _c('GlobalSidebarMenu', {
    staticClass: "global-sidebar sidebar-content",
    attrs: {
      "menu": _vm.getGlobalMenu()
    }
  }) : _vm._e(), _vm.isSidebarVisible ? _c('div', {
    class: ['sidebar-footer', {
      'footer-closed': !_vm.isFooterOpen,
      'pt-2': !_vm.isMobileLandscape
    }]
  }, [_vm.isMobileLandscape ? _c('div', {
    staticClass: "w-100 d-flex my-2"
  }, [_c('button', {
    staticClass: "toggle-footer-button w-100 border-0",
    staticStyle: {
      "background-color": "var(--theme-primary)",
      "color": "var(--theme-tertiary)"
    },
    on: {
      "click": _vm.toggleFooter
    }
  }, [_c('i', {
    class: _vm.isFooterOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-up'
  })])]) : _vm._e(), _vm.isFooterOpen ? [_c('router-link', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3",
    attrs: {
      "to": {
        path: '/admin/search'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onItemClick2.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-magnifying-glass text-primary"
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t("admin.search")) + " ")])]), _c('div', {
    staticClass: "mb-2"
  }), _c('router-link', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3",
    attrs: {
      "to": {
        path: '/user/settings'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onItemClick2.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-gear text-primary"
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t("User Settings")) + " ")])]), _c('div', {
    staticClass: "mb-2"
  }), _c('router-link', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3",
    attrs: {
      "to": {
        path: '/'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onItemClick2();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-globe text-primary"
  }), _c('span', {
    staticClass: "user-title"
  }, [_vm._v(_vm._s(_vm.$t("Back")))])]), _c('div', {
    staticClass: "mb-2"
  })] : _vm._e()], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }